module.exports = __webpack_public_path__ + "img/item-info-icon9.109a269e.svg";